<!--
 * @Author: guojia 66291979@qq.com
 * @Date: 2024-08-05 11:58:18
 * @LastEditors: pluto.guo 66291979@qq.com
 * @LastEditTime: 2024-12-27 19:23:40
 * @FilePath: /lobby/src/components/RushDepositButton.vue
 * @Description: 
 * 
 * Copyright (c) 2024 by ${git_name_email}, All Rights Reserved. 
-->
<template>
  <div
    @click="onBtnClicked"
    ref="floatButton"
    class="float-info"
    :style="{
      width: itemWidth + 'px',
      height: itemHeight + 'px',
      left: left + 'px',
      top: top + 'px'
    }"
  >
    <img :src="`${resBaseUrl}rush_deposit_float_button.png`" alt="" />
  </div>
</template>

<script>
// import { Crisp } from 'crisp-sdk-web'
import { config } from '@/common/config'
import { useUserStore } from '@/stores/user'
import { mapState } from 'pinia'
export default {
  components: {},
  data() {
    return {
      clientWidth: 0, // 页面宽度
      clientHeight: 0, // 页面高度
      timer: null,
      currentTop: 0,
      left: 0,
      top: 0,
      showChat: false,
      oldScrollTop: 0, //记录上一次滚动结束后的滚动距离
      scrollTop: 0, // 记录当前的滚动距离
      resBaseUrl: config.resBaseUrl
    }
  },
  props: {
    itemWidth: {
      // 按钮宽度
      type: Number,
      default: 55
    },
    itemHeight: {
      // 按钮高度
      type: Number,
      default: 55
    },
    gapWidth: {
      // 距离左右两边距离
      type: Number,
      default: 15
    },
    coefficientHeight: {
      // 从上到下距离比例
      type: Number,
      default: 0.8
    }
  },
  watch: {
    scrollTop(newValue, oldValue) {
      if (this.oldScrollTop == oldValue) {
        //每次滚动开始时oldScrollTop与oldValue相等
        //console.log('滚动开始');
        if (this.left === 15) {
          this.left = this.left - 40
        } else {
          this.left = this.left + 40
        }
      }
      setTimeout(() => {
        if (newValue == window.scrollY) {
          //延时执行后当newValue等于window.scrollY，代表滚动结束
          //console.log('滚动结束');
          if (this.left === 15) {
            //按钮在页面左侧
            this.left = this.left + 40
          } else if (this.left < 15) {
            this.left = 15
          } else {
            this.left = this.left - 40
          }
          this.oldScrollTop = newValue //每次滚动结束后都要给oldScrollTop赋值
        }
      }, 20) //必须使用延时器，否则每次newValue和window.scrollY都相等，无法判断，20ms刚好大于watch的侦听周期，故延时20ms
    }
  },
  created() {
    this.clientWidth = document.documentElement.clientWidth
    this.clientHeight = document.documentElement.clientHeight
    this.left = this.clientWidth - this.itemWidth - this.gapWidth
    this.top = this.clientHeight * this.coefficientHeight
  },
  mounted() {
    this.$nextTick(() => {
      const floatButton = this.$refs.floatButton
      floatButton.addEventListener('touchstart', () => {
        floatButton.style.transition = 'none'
      })

      // 在拖拽的过程中，组件应该跟随手指的移动而移动。
      floatButton.addEventListener('touchmove', (e) => {
        if (e.targetTouches.length === 1) {
          // 一根手指
          document.body.addEventListener('touchmove', this.bodyScroll, { passive: false }) //禁止页面滑动
          let touch = e.targetTouches[0]
          this.left = touch.clientX - 20
          this.top = touch.clientY - 25
        }
      })

      // 拖拽结束以后，重新调整组件的位置并重新设置过度动画。
      floatButton.addEventListener('touchend', () => {
        document.body.removeEventListener('touchmove', this.bodyScroll, { passive: false }) //解除页面禁止滑动
        floatButton.style.transition = 'all 0.3s'
        if (this.left > document.documentElement.clientWidth / 2) {
          this.left = document.documentElement.clientWidth - 70
        } else {
          this.left = 15
        }
      })
    })
    // 监听scroll事件获取滚动距离
    window.addEventListener('scroll', () => {
      this.scrollTop = window.scrollY
    })
  },
  computed: {
    ...mapState(useUserStore, ['country', 'isLogin', 'balance', 'userInfo'])
  },
  methods: {
    onBtnClicked() {
      this.$router.push({ name: 'RushDeposit' })
    }
  }
}
</script>

<style lang="scss" scoped>
.float-info {
  // box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.1);
  transition: all 0.3s;
  position: fixed;
  bottom: 50px;
  right: 30px;
  width: 55px;
  height: 55px;
  display: flex;
  flex-flow: column;
  justify-content: center;
  align-items: center;
  z-index: 999;
  background-color: rgba($color: #000000, $alpha: 0);
  border-radius: 50%;
  cursor: pointer;
  img {
    width: 100%;
    height: 100%;
  }
}
</style>
